<template>
  <div
    :class="{
      'text-muted': !confirmed,
      'text-success': confirmed,
      'font-weight-bold': confirmed}"
    v-b-tooltip.left.hover :title="tooltipContent"><i class="fa fa-check-square-o" aria-hidden="true"></i><slot></slot>
  </div>
</template>
<script>
import dateMixin from '../mixins/date';

export default {
  props: ['label', 'confirmed', 'adt-data'],
  mixins: [dateMixin],
  computed: {
    tooltipContent() {
      if (this.confirmed) {
        const { adtData } = this;
        return `${adtData.name}: ${this.formatDateTime(adtData.created_at)}`;
      }
      return 'Unconfirmed';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ConfirmChecklist.vue